import React from 'react'
import moment from 'moment'

export default class MustHeader extends React.Component {
  constructor(props) {
    super(props)
    const promotions = this.props.promotions
    if (!promotions || promotions.length == 0) return null
    this.state = {
      promotionIndex: Math.floor(Math.random() * promotions.length),
    }
  }

  render() {
    const promotions = this.props.promotions
    if (!promotions || promotions.length == 0) return null
    const promotion = promotions[this.state.promotionIndex]
    const backgroundImage = promotion.background_image
      ? `url(${promotion.background_image})`
      : 'none'
    let startedAt = moment(promotion.started_at).utc()
    let endedAt = moment(promotion.ended_at).utc()

    return (
      <a
        href={Routes.promotion_path(promotion)}
        className="site-header__campaign"
        style={{
          color: promotion.text_color,
          backgroundColor: promotion.background_color,
          backgroundImage: backgroundImage,
          backgroundRepeat: 'repeat',
        }}
      >
        <div className="site-header__campaign-date-box">
          <div className="site-header__campaign-date-box-inner">
            <p className="site-header__campaign-date">
              {moment(endedAt).format('YYYY年')}
              <br />
              {moment(endedAt).format('M月D日')}
              <br />
              まで
            </p>
          </div>
        </div>
        <p className="site-header__campaign-title">{promotion.title}</p>
        <div className="site-header__campaign-button-box">
          <div
            style={{ color: promotion.link_color }}
            className="button-white site-header__campaign-button"
          >
            キャンペーン詳細へ
          </div>
        </div>
      </a>
    )
  }
}
